import { Component, Input, OnInit } from "@angular/core";
import { AuthenticationService, EnvironmentConfig } from "../../../core/core";
import { User } from "oidc-client";
import { Activity } from "../../models/activity.model";
import { ActivityService } from "../../services/activity.service";
import { generate, observe } from "fast-json-patch";
import { ToastrService } from "ngx-toastr";

declare const environment: EnvironmentConfig;

@Component({
  selector: "common-activity-type-base",
  templateUrl: "./activity-type-base.component.html",
})
export class ActivityTypeBaseComponent implements OnInit {
  @Input() activity: Activity;
  @Input() showStatus: boolean = true;
  @Input() pendingReviewBanner = { message: "An admin has been notified and will be reviewing.", class: "alert-warning" };

  user: User;
  environment = environment;

  noCards = ["INSPECTION-OWNER-CHECKIN", "INSPECTION-OWNER-CHECKOUT", "INSPECTION-RENTER-CHECKIN", "INSPECTION-RENTER-CHECKOUT", "BUYITNOW-INSPECTION"];
  cardClass: boolean;

  constructor(public activityService: ActivityService, private authService: AuthenticationService, public toastr: ToastrService) {}

  ngOnInit(): void {
    this.user = this.authService.getUserNonAsync();
    this.cardClass = !this.noCards.includes(this.activity.activityCode);
  }

  approve() {
    if (environment.clientId != "rubbl.admin") {
      return;
    }

    if (!confirm("Are you sure you want to approve?")) {
      return;
    }

    const watcher = observe(this.activity);
    this.activity.status = "Closed";
    this.activity.approvedAdminId = this.user.profile.sub;
    this.activity.adminApproved = true;
    this.activity.adminApprovedDateTime = new Date().toDateString();
    delete this.activity.metadata["deniedReason"];
    const patch = generate(watcher);

    this.activityService.jsonPatchWithPartitionKey(this.activity.id, patch, this.activity.accountId).subscribe(result => {
      this.toastr.success("Approved");
    });
  }

  deny() {
    let deniedReason = prompt("What is the reason?");
    if (!deniedReason) {
      return;
    }

    const watcher = observe(this.activity);
    this.activity.status = "Denied";
    this.activity.adminApproved = false;
    this.activity.adminApprovedDateTime = null;
    this.activity.metadata["deniedReason"] = deniedReason;
    const patch = generate(watcher);

    this.activityService.jsonPatchWithPartitionKey(this.activity.id, patch, this.activity.accountId).subscribe(result => {
      this.toastr.success("Denied");
    });
  }

  resetActivity() {
    if (environment.clientId != "rubbl.admin") {
      return;
    }

    if (!confirm("Are you sure you want to reset?")) {
      return;
    }

    const watcher = observe(this.activity);
    this.activity.status = "Open";
    this.activity.adminApproved = false;
    this.activity.metadata = {};
    this.activity.storageModel = null;
    this.activity.storageModels = [];

    const patch = generate(watcher);
    this.activityService.jsonPatchWithPartitionKey(this.activity.id, patch, this.activity.accountId).subscribe(result => {
      this.toastr.success("Reset successful");
    });
  }
}
